import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSessionJWT, useNavigatorOnline } from "utils";
import { KYC_POLL_INTERVAL } from "env";

import { getKYCStatus } from "../pii";

const DEFAULT_INTERVAL = Number(KYC_POLL_INTERVAL) || 5000;

/**
 * Polling for KYC status, given a KYC ID. Also handles checking of network status
 * to start/stop the polling based on whether or not the user is online.
 * @name usePollKYCStatus
 * @author magnus
 * @param {String} kycId
 * @param {Boolean} [enabled]
 */
export default function usePollKYCStatus(kycId, enabled = true) {
  const { sessionJWT } = useSessionJWT();
  const { status } = useNavigatorOnline();
  const [refetchInterval, setRefetchInterval] = useState(DEFAULT_INTERVAL);

  useEffect(() => {
    if (status === "offline") {
      setRefetchInterval(0);
    } else {
      setRefetchInterval(DEFAULT_INTERVAL);
    }
  }, [status]);

  return useQuery({
    queryKey: ["kyc", "details", kycId],
    queryFn: () => getKYCStatus(sessionJWT, kycId),
    refetchInterval,
    enabled,
  });
}
